module.exports = __webpack_public_path__ + "img/Home-2.52aa994a.jpg";